var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpuSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 16.0001C33.3334 9.33342 30.6667 6.66675 24.0001 6.66675H16.0001C9.33342 6.66675 6.66675 9.33342 6.66675 16.0001V24.0001C6.66675 30.6667 9.33342 33.3334 16.0001 33.3334",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2501 13.3334C26.3334 12.1667 24.8001 11.6667 22.5001 11.6667H17.5001C13.3334 11.6667 11.6667 13.3334 11.6667 17.5001V22.5001C11.6667 24.8001 12.1667 26.3334 13.3167 27.2501",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3501 6.66659V3.33325",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.66659V3.33325",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 6.66659V3.33325",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 13.3333H36.6666",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3501 33.3333V36.6666",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 13.3333H6.66659",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 20H6.66659",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 26.6667H6.66659",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8499 30.9834C29.3135 30.9834 30.4999 29.7969 30.4999 28.3334C30.4999 26.8698 29.3135 25.6833 27.8499 25.6833C26.3864 25.6833 25.2 26.8698 25.2 28.3334C25.2 29.7969 26.3864 30.9834 27.8499 30.9834Z",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0166 29.1V27.55C19.0166 26.6334 19.7666 25.8834 20.6833 25.8834C22.2833 25.8834 22.9333 24.75 22.1333 23.3667C21.6666 22.5667 21.9499 21.5334 22.7499 21.0834L24.2666 20.2C24.9666 19.7834 25.8666 20.0334 26.2833 20.7334L26.3833 20.9C27.1833 22.2834 28.4833 22.2834 29.2833 20.9L29.3833 20.7334C29.7999 20.0334 30.6999 19.8 31.3999 20.2L32.9166 21.0834C33.7166 21.55 33.9999 22.5667 33.5333 23.3667C32.7333 24.75 33.3833 25.8834 34.9833 25.8834C35.8999 25.8834 36.6499 26.6334 36.6499 27.55V29.1C36.6499 30.0167 35.8999 30.7667 34.9833 30.7667C33.3833 30.7667 32.7333 31.9 33.5333 33.2834C33.9999 34.0834 33.7166 35.1167 32.9166 35.5667L31.3999 36.45C30.6999 36.8667 29.7999 36.6167 29.3833 35.9167L29.2833 35.75C28.4833 34.3667 27.1833 34.3667 26.3833 35.75L26.2833 35.9167C25.8666 36.6167 24.9666 36.85 24.2666 36.45L22.7499 35.5667C21.9499 35.1 21.6666 34.0834 22.1333 33.2834C22.9333 31.9 22.2833 30.7667 20.6833 30.7667C19.7666 30.7834 19.0166 30.0334 19.0166 29.1Z",
    stroke: "#2C3131",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpuSetting);
export default __webpack_public_path__ + "static/media/cpu-setting.7d927951d921aff3a18c949010302635.svg";
export { ForwardRef as ReactComponent };